import Fade from "@mui/material/Fade";
import Popper, { PopperProps } from "@mui/material/Popper";
import { styled } from "@mui/material/styles";
import React, { FunctionComponent } from "react";
import PopperPaper from "./PopperPaper";
import { PaperProps } from "@mui/material";

const StyledPopper = styled(Popper)(({
	theme,
}) => ({
	/** the dropdown should be above of modal */
	zIndex: theme.zIndex.modal + 1,

}));

const getModifiers = (flipOnOverflow: boolean) => [
	{
		name: "flip",
		enabled: !!flipOnOverflow,
	},
	{
		name: "preventOverflow",
		enabled: true,
		options: {
			boundary: "parentNode",
		},
	},
];

export interface PopperInContainerProps extends Omit<PopperProps, "children" | "modifiers" | "open" | "placement" | "transition"> {
	/** keep the children the same as it's defined in PaperProps  */
	children?: React.ReactNode;

	/** flip the popper on overflow */
	flipOnOverflow?: boolean;

	/** the properties will be applied to the paper  */
	paperProps?: PaperProps;
}

const PopperInContainer: FunctionComponent<PopperInContainerProps> = (props) => {
	// deals with both the zIndex and disablePortal, normally use this component in dialog where we don't want the content flip, otherwise, we could use the MUI one instead
	const { children, className, flipOnOverflow, paperProps = {}, ...otherProps } = props;
	const modifiers = getModifiers(flipOnOverflow);

	return (
		<StyledPopper
			modifiers={modifiers}
			open={!!props.anchorEl}
			placement="bottom-start"
			transition
			{...otherProps}
		>
			{({ TransitionProps }) => (
				<Fade {...TransitionProps} timeout={250}>
					<PopperPaper {...paperProps}>
						{children}
					</PopperPaper>
				</Fade>
			)}
		</StyledPopper>
	);
};

export default PopperInContainer;